import React, { useState } from 'react';
import {
    Alert,
    Button,
    Collapse,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    LinearProgress,
    Snackbar,
    TextField,
    Typography,
} from '@material-ui/core';
import { useRecoilValue } from 'recoil';
import { ServiceStackClient } from '../../Recoil/Atoms';
import { ContactSupport } from '../../ServiceStack/ServiceStack.dtos';

export interface ISupportFormProps {
    isPasswordChange: boolean;
    show: boolean;
    onClose: () => void;
}

const SupportForm: React.FC<ISupportFormProps> = (props) => {
    const client = useRecoilValue(ServiceStackClient);
    const [userFeedback, setUserFeedback] = useState('');
    const [sending, setSending] = useState(false);
    const [showErrorSnackbar, setShowErrorSnackbar] = useState(false);
    const [showSuccessSnackbar, setShowSuccessSnackbar] = useState(false);

    const sendFeedback = () => {
        setSending(true);
        client
            .post(new ContactSupport({ feedback: userFeedback, subject: window.location.href }))
            .then(() => {
                setSending(false);
                setShowSuccessSnackbar(true);
                props.onClose();
            })
            .catch((error) => {
                setSending(false);
                setShowErrorSnackbar(true);
                props.onClose();
            });
    };

    const onBackdropClick = () => {
        if (!userFeedback || userFeedback.length === 0) props.onClose();
    };

    const isDisabled = sending || !userFeedback || userFeedback.trim().length === 0;

    return (
        <>
            <Dialog
                open={props.show}
                onClose={() => props.onClose}
                aria-labelledby='alert-dialog-title'
                aria-describedby='alert-dialog-description'
                onBackdropClick={onBackdropClick}
            >
                <Collapse in={sending}>
                    <LinearProgress variant='indeterminate' />
                </Collapse>
                <DialogTitle id='alert-dialog-title'>Contact Support</DialogTitle>
                <DialogContent>
                    <DialogContentText id='alert-dialog-description'>
                        {props.isPasswordChange
                            ? 'Contact support to change you password. Your new password will be emailed to you.'
                            : "Please share your feedback or issue with us! We'll get in touch!"}
                    </DialogContentText>
                    {props.isPasswordChange ? (
                        <TextField fullWidth variant='outlined' onChange={(e) => setUserFeedback(e.target.value)} placeholder='Email' />
                    ) : (
                        <TextField
                            fullWidth
                            multiline
                            rows={3}
                            variant='outlined'
                            onChange={(e) => setUserFeedback(e.target.value)}
                            placeholder='Details here...'
                        />
                    )}
                </DialogContent>
                <DialogActions>
                    <Button onClick={props.onClose}>Cancel</Button>
                    <Button onClick={sendFeedback} color='primary' disabled={isDisabled}>
                        Send
                    </Button>
                </DialogActions>
            </Dialog>
            {/*ToDo add common snackbar to AppLayout and control through recoil*/}
            <Snackbar
                open={showErrorSnackbar}
                anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
                autoHideDuration={6000}
                onClose={() => setShowErrorSnackbar(false)}
            >
                <Alert severity={'error'} onClose={() => setShowErrorSnackbar(false)}>
                    <Typography>There was a problem contacting support!</Typography>
                </Alert>
            </Snackbar>
            <Snackbar
                open={showSuccessSnackbar}
                anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
                autoHideDuration={6000}
                onClose={() => setShowSuccessSnackbar(false)}
            >
                <Alert severity={'success'} onClose={() => setShowSuccessSnackbar(false)}>
                    <Typography>Your feedback has been sent!</Typography>
                </Alert>
            </Snackbar>
        </>
    );
};

export { SupportForm };
